module.exports = __webpack_public_path__ + "static/img/10.c1b93a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/10.png
// module id = fwSR
// module chunks = 0